const _ = require('lodash');
export default async function getRoleList(companyUserObject, role) {
  let dataSet  = _.cloneDeep(companyUserObject)
  if(!role) return dataSet
  let allPermission = ["isAdmin", "isPaymentAdmin", "isDocsWriter", "isGraphReader", "isDocsReader", "isDeveloper"]
  let roleName = {
    "owner": ["isAdmin", "isPaymentAdmin", "isDocsWriter", "isGraphReader", "isDocsReader"],
    "developer": ["isAdmin", "isPaymentAdmin", "isDocsWriter", "isGraphReader", "isDocsReader", "isDeveloper"],
    "user": ["isDocsWriter", "isGraphReader", "isDocsReader"],
  }

  await allPermission.forEach((data) => {
    dataSet[data] = roleName[role].includes(data);
  })
  return dataSet
}

